import { activeSiteConfig } from "@config/site/site-config";
import type { Cart, Money } from "@graphql/generated/types";
import { roundPrice } from "@lib/utils/moneyUtils";

// This should be removed after backend introduces a good way to get a promo discount value.

// After GLOBALCOM-5358, we are no longer adding the shipping discount to the target discount.
// This is because when we apply a code that gives a discount on shipping, the shipping fee
// is updated to be 0 in the summary component, so there is no visual cue that the user is
// paying for the shipping. Thus, showing a discount makes it confusing for the user.
export const getPromoCodeDiscountValue = (targetId: string, cart: Cart) => {
    const cartItems = cart?.lineItems;

    let targetDiscount: Money;

    const targetCode = cart.discountCodes?.find((code) => code.discountCode.id === targetId);

    const targetCartDiscountIds = targetCode?.discountCode?.cartDiscounts?.map(({ id }) => id);

    let discountSum = 0;

    cartItems.forEach((item) => {
        item.discountedPricePerQuantity.forEach((discount) => {
            const includedDiscount = discount.discountedPrice.includedDiscounts.find(
                (includedDiscount) => targetCartDiscountIds?.includes(includedDiscount.discount?.id)
            );

            if (!includedDiscount) return;

            let discountCentAmount = includedDiscount.discountedAmount.centAmount;

            // If the market requires rounding round the discount up.
            if (activeSiteConfig.roundingUnit) {
                discountCentAmount = roundPrice(discountCentAmount, "ceil");
            }

            discountSum += discountCentAmount * discount.quantity;

            if (targetDiscount) return;

            targetDiscount = includedDiscount.discountedAmount;
        });
    });

    if (!targetDiscount) return null;

    return {
        ...targetDiscount,
        centAmount: discountSum,
    };
};
